module.exports = __webpack_public_path__ + "static/media/nissan-navara.82b870c4.jpg";